type TProps = {
  selectedId: string | undefined;
  subcategoryId: string | undefined;
  parentDict: Record<string, string>;
};

export const getOpenIds = ({
  selectedId,
  subcategoryId,
  parentDict,
}: TProps): Set<string> => {
  if (!selectedId) {
    return new Set();
  }

  const result = [selectedId];

  if (subcategoryId) {
    result.push(subcategoryId);
    result.push(parentDict[subcategoryId]);
  } else {
    let target = selectedId;

    while (parentDict[target]) {
      result.push(parentDict[target]);
      target = parentDict[target];
    }
  }

  return new Set(result);
};
